import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { X } from '@/lib/socialProfile';

import { HalfBarChart } from '@/components/composite/Charts/HalfBarChart';

export const postEngagementTimelineConfig: ChartType<typeof HalfBarChart> = {
    title: 'chart.twitter.post_engagement_timeline',
    tooltip: 'chart.twitter.post_engagement_timeline_tooltip',
    id: 'post_engagements_history',
    margin: {
        left: -25,
        bottom: 20
    },
    orientation: 'horizontal',
    isStacked: true,
    name: {
        date: 'date',
        total: 'total',
        likes: 'chart.post_engagements.likes',
        replies: 'chart.post_engagements.replies',
        reposts: 'chart.post_engagements.reposts',
        quotes: 'chart.post_engagements.quotes',
        bookmarks: 'chart.post_engagements.bookmarks'
    },
    social: X,
    valueFormat: classicFormat,
    size: SIZE_FULL,
    type: 'chart',
    element: HalfBarChart,
    color: {
        likes: 'red',
        replies: 'blue',
        reposts: 'aquablue',
        quotes: 'purple',
        bookmarks: 'yellow'
    }
};
